import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { NetworkTopGroupsLoadAction } from '../../domains/networkTopGroups/actions.types';

import { NetworkTopGroupsLifecycle } from './types';

const initialState: NetworkTopGroupsLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<NetworkTopGroupsLifecycle, NetworkTopGroupsLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'NETWORK_TOP_GROUPS.LOAD_PENDING':
      return setPending();
    case 'NETWORK_TOP_GROUPS.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.networkTopGroups);
    case 'NETWORK_TOP_GROUPS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
